import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { ROLES } from "../../utilities/constants";
import ErrorPage from "../../utilities/pages/ErrorPage/ErrorPage";
import { getUserInfo } from "../../utilities/storage";
import AdminFormForDeptAdmin from "../Administrators/components/AdminFormForDeptAdmin/AdminFormForDeptAdmin";
import AdminFormForOrgAdmin from "../Administrators/components/AdminFormForOrgAdmin/AdminFormForOrgAdmin";
import AppointmentForm from "../Appointments/components/AppointmentForm/AppointmentForm";
import AppointmentInsight from "../Appointments/components/AppointmentInsight/AppointmentInsight";
import AppointmentsList from "../Appointments/components/AppointmentsList/AppointmentsList";
import Patient from "../Athletes/components/PatientProfile/PatientProfile";
import Patients from "../Athletes/components/Patients/Patients";
import AddCase from "../Cases/components/CaseForm/CaseForm";
import Case from "../Cases/components/CaseProfile/CaseProfile";
import Cases from "../Cases/components/CasesList/CasesList";
import DepartmentForm from "../Departments/components/DepartmentForm/DepartmentForm";
import DepartmentProfile from "../Departments/components/DepartmentProfile/DepartmentProfile";
import DoctorForm from "../Doctors/components/DoctorForm/DoctorForm";
import AddHeadOrg from "../HeadOrgs/components/HeadOrgForm/HeadOrgForm";
import HeadOrgList from "../HeadOrgs/components/HeadOrgList/HeadOrgList";
import HeadOrgProfile from "../HeadOrgs/components/HeadOrgProfile/HeadOrgProfile";
import NewUpdates from "../NewUpdates/components/NewUpdatesList/NewUpdatesList";
import OrganisationProfile from "../Organizations/components/OrganisationProfile/OrganisationProfile";
import AddOrganization from "../Organizations/components/OrganizationForm/OrganizationForm";
import Organizations from "../Organizations/components/OrganizationsList/OrganizationsList";
import PatientForm from "../Patients/PatientForm/PatientForm";
import PatientProfile from "../Patients/PatientProfile/PatientProfile";
import ProfilePageFormAdminUsers from "../Users/components/AdminUsersProfile/AdminUsersProfile";
import ProfilePageForUsers from "../Users/components/DoctorProfile/DoctorProfile";
import EditProfileFormForUsers from "../Users/components/EditProfileFormForDoctors/EditProfileFormForDoctors";
import EditProfileFormForAdminUsers from "../Users/components/EditUserFormForAdmins/EditUserFormForAdmins";
import Users from "../Users/components/UsersList/UsersList";
import MedicineList from "../MedicineList/components/MedicineList";
import Setting from "../Organizations/components/Setting/Setting";
import DoctorHome from "../HomePage/DoctorHome";
import FollowUpDashboard from "../Followup/FollowUpDashboard";

/**
 * function to render routes
 * @returns {JSX.Element}
 * @constructor
 */
const DashboardRoutes = ({ selectedDept }) => {
  const role = getUserInfo().Roles[0].name;
  switch (role) {
    case ROLES.ROLE_SUPER_ADMIN:
      return (
        <Switch>
          <Route exact path="/" component={() => <Redirect to="/headorgs" />} />
          {/* profile routes */}
          <Route exact path="/profile" component={ProfilePageFormAdminUsers} />
          <Route
            exact
            path="/profile/edit/:id"
            component={EditProfileFormForAdminUsers}
          />

          {/* users routes */}
          <Route exact path="/users" component={Users} />
          <Route
            exact
            path="/users/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/users/edit/:id"
            component={EditProfileFormForAdminUsers}
          />

          {/* orgs routes */}
          <Route exact path="/orgs" component={Organizations} />
          <Route exact path="/orgs/add" component={AddOrganization} />
          <Route exact path="/orgs/addDepartment" component={DepartmentForm} />
          <Route exact path="/orgs/addDoctor" component={DoctorForm} />
          <Route exact path="/orgs/addAdmin" component={AdminFormForOrgAdmin} />
          <Route exact path="/orgs/edit/:id" component={AddOrganization} />
          <Route exact path="/orgs/:id" component={OrganisationProfile} />

          {/* Organizer routes */}
          <Route exact path="/headorgs" component={HeadOrgList} />
          <Route exact path="/headorgs/add" component={AddHeadOrg} />
          <Route exact path="/headorgs/edit/:id" component={AddHeadOrg} />
          <Route exact path="/headorgs/:id" component={HeadOrgProfile} />

          {/* orgs doctors routes  */}
          <Route
            exact
            path="/orgs/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />

          {/* orgs admins routes  */}
          <Route
            exact
            path="/orgs/admins/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/admins/:id"
            component={ProfilePageFormAdminUsers}
          />

          {/* orgs depts routes  */}
          <Route
            exact
            path="/orgs/departments/addPatient"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/addDoctor"
            component={DoctorForm}
          />
          <Route
            exact
            path="/orgs/departments/addAdmin"
            component={AdminFormForDeptAdmin}
          />
          <Route
            exact
            path="/orgs/departments/patients/edit/:id"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/patients/:id"
            component={PatientProfile}
          />

          <Route
            exact
            path="/orgs/departments/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/admins/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/admins/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/edit/:id"
            component={DepartmentForm}
          />
          <Route
            exact
            path="/orgs/departments/:id"
            component={DepartmentProfile}
          />

          <Route
            component={() => (
              <ErrorPage
                code={403}
                message="You do not have access to view this page."
              />
            )}
          />
        </Switch>
      );
    case ROLES.ROLE_SYSTEM_ADMIN:
      return (
        <Switch>
          <Route exact path="/" component={() => <Redirect to="/orgs" />} />
          {/* profile routes */}
          <Route exact path="/profile" component={ProfilePageFormAdminUsers} />
          <Route
            exact
            path="/profile/edit"
            component={EditProfileFormForAdminUsers}
          />

          {/* users routes */}
          <Route exact path="/users" component={Users} />
          <Route
            exact
            path="/users/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/users/edit/:id"
            component={EditProfileFormForAdminUsers}
          />

          {/* orgs routes */}
          <Route exact path="/orgs" component={Organizations} />
          <Route exact path="/orgs/add" component={AddOrganization} />
          <Route exact path="/orgs/addDepartment" component={DepartmentForm} />
          <Route exact path="/orgs/addDoctor" component={DoctorForm} />
          <Route exact path="/orgs/addAdmin" component={AdminFormForOrgAdmin} />
          <Route exact path="/orgs/edit/:id" component={AddOrganization} />
          <Route exact path="/orgs/:id" component={OrganisationProfile} />

          {/* Organizer routes */}
          <Route exact path="/headorgs" component={HeadOrgList} />
          <Route exact path="/headorgs/add" component={AddHeadOrg} />
          <Route exact path="/headorgs/edit/:id" component={AddHeadOrg} />
          <Route exact path="/headorgs/:id" component={HeadOrgProfile} />

          {/* orgs doctors routes  */}
          <Route
            exact
            path="/orgs/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />

          {/* orgs admins routes  */}
          <Route
            exact
            path="/orgs/admins/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/admins/:id"
            component={ProfilePageFormAdminUsers}
          />

          {/* orgs depts routes  */}
          <Route
            exact
            path="/orgs/departments/addPatient"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/addDoctor"
            component={DoctorForm}
          />
          <Route
            exact
            path="/orgs/departments/addAdmin"
            component={AdminFormForDeptAdmin}
          />
          <Route
            exact
            path="/orgs/departments/patients/edit/:id"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/patients/:id"
            component={PatientProfile}
          />

          <Route
            exact
            path="/orgs/departments/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/admins/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/admins/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/edit/:id"
            component={DepartmentForm}
          />
          <Route
            exact
            path="/orgs/departments/:id"
            component={DepartmentProfile}
          />

          <Route
            component={() => (
              <ErrorPage
                code={403}
                message="You do not have access to view this page."
              />
            )}
          />
        </Switch>
      );
    case ROLES.ROLE_CLINIC_OWNER:
      return (
        <Switch>
          <Route exact path="/" component={() => <Redirect to="/orgs" />} />
          {/* profile routes */}
          <Route exact path="/profile" component={ProfilePageFormAdminUsers} />
          <Route
            exact
            path="/profile/edit/:id"
            component={EditProfileFormForAdminUsers}
          />

          {/* users routes */}
          <Route exact path="/users" component={Users} />
          <Route
            exact
            path="/users/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/users/edit/:id"
            component={EditProfileFormForAdminUsers}
          />

          {/* medicine list routes */}
          <Route exact path="/medicineInventory" component={MedicineList} />

          {/* orgs routes */}
          <Route exact path="/orgs" component={Organizations} />
          <Route exact path="/orgs/add" component={AddOrganization} />
          <Route exact path="/orgs/addDepartment" component={DepartmentForm} />
          <Route exact path="/orgs/addDoctor" component={DoctorForm} />
          <Route exact path="/orgs/addAdmin" component={AdminFormForOrgAdmin} />
          <Route exact path="/orgs/edit/:id" component={AddOrganization} />
          <Route exact path="/orgs/:id" component={OrganisationProfile} />

          {/* Organizer routes */}
          <Route exact path="/headorgs" component={HeadOrgList} />
          <Route exact path="/headorgs/add" component={AddHeadOrg} />
          <Route exact path="/headorgs/edit/:id" component={AddHeadOrg} />
          <Route exact path="/headorgs/:id" component={HeadOrgProfile} />

          {/* orgs doctors routes  */}
          <Route
            exact
            path="/orgs/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />

          {/* orgs admins routes  */}
          <Route
            exact
            path="/orgs/admins/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/admins/:id"
            component={ProfilePageFormAdminUsers}
          />

          {/* orgs depts routes  */}
          <Route
            exact
            path="/orgs/departments/addPatient"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/addDoctor"
            component={DoctorForm}
          />
          <Route
            exact
            path="/orgs/departments/addAdmin"
            component={AdminFormForDeptAdmin}
          />
          <Route
            exact
            path="/orgs/departments/patients/edit/:id"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/patients/:id"
            component={PatientProfile}
          />

          <Route
            exact
            path="/orgs/departments/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/admins/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/admins/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/edit/:id"
            component={DepartmentForm}
          />
          <Route
            exact
            path="/orgs/departments/:id"
            component={DepartmentProfile}
          />

          <Route
            component={() => (
              <ErrorPage
                code={403}
                message="You do not have access to view this page."
              />
            )}
          />
        </Switch>
      );

    case ROLES.ROLE_ORG_ADMIN:
      return (
        <Switch>
          <Route
            exact
            path="/"
            component={() => <Redirect to="/newUpdates" />}
          />
          {/* users routes  */}
          <Route exact path="/profile" component={ProfilePageForUsers} />
          <Route
            exact
            path="/profile/edit"
            component={EditProfileFormForUsers}
          />

          <Route exact path="/newUpdates" component={NewUpdates} />
          <Route exact path="/cases/addCase" component={AddCase} />
          <Route exact path="/cases" component={Cases} />
          <Route exact path="/cases/:id" component={Case} />
          <Route exact path="/patients/:id" component={Patient} />
          <Route exact path="/patients" component={Patients} />

          {/* org admin routes  */}
          <Route exact path="/orgs" component={Organizations} />
          <Route
            exact
            path="/orgs/add"
            component={() => (
              <ErrorPage
                code={403}
                message="You do not have access to view this page."
              />
            )}
          />
          <Route exact path="/users" component={Users} />
          <Route
            exact
            path="/users/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/users/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          {/* nested access routes  */}
          <Route exact path="/orgs/addDepartment" component={DepartmentForm} />
          <Route exact path="/orgs/addDoctor" component={DoctorForm} />
          <Route exact path="/orgs/edit/:id" component={AddOrganization} />
          <Route exact path="/orgs/:id" component={OrganisationProfile} />
          <Route exact path="/orgs/:id" component={OrganisationProfile} />
          <Route exact path="/setting" component={Setting} />

          <Route
            exact
            path="/appointment/insight"
            component={AppointmentInsight}
          />

          {/* medicine list routes */}
          <Route exact path="/medicineInventory" component={MedicineList} />

          {/* orgs doctors routes  */}
          <Route
            exact
            path="/orgs/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />

          {/* orgs depts routes  */}
          <Route
            exact
            path="/orgs/departments/addPatient"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/addDoctor"
            component={DoctorForm}
          />
          <Route
            exact
            path="/orgs/departments/addAdmin"
            component={AdminFormForDeptAdmin}
          />
          <Route
            exact
            path="/orgs/departments/patients/edit/:id"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/patients/:id"
            component={PatientProfile}
          />

          <Route
            exact
            path="/orgs/departments/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />

          <Route
            exact
            path="/orgs/departments/edit/:id"
            component={DepartmentForm}
          />
          <Route
            exact
            path="/orgs/departments/:id"
            component={DepartmentProfile}
          />

          <Route
            component={() => (
              <ErrorPage
                code={403}
                message="You do not have access to view this page."
              />
            )}
          />
        </Switch>
      );

    case ROLES.ROLE_DOCTOR:
      return (
        <Switch>
          <Route exact path="/" component={() => <Redirect to="/home" />} />
          {/* users routes  */}
          <Route exact path="/profile" component={ProfilePageForUsers} />
          <Route
            exact
            path="/profile/edit"
            component={EditProfileFormForUsers}
          />
          <Route exact path="/home" component={DoctorHome} />
          <Route exact path="/newUpdates" component={NewUpdates} />
          <Route exact path="/followup" component={FollowUpDashboard} />
          <Route exact path="/cases/addCase" component={AddCase} />
          <Route exact path="/cases" component={Cases} />
          <Route exact path="/cases/:id" component={Case} />
          <Route exact path="/patients/:id" component={Patient} />
          <Route exact path="/patients" component={Patients} />

          {/* org admin routes  */}
          <Route exact path="/orgs" component={Organizations} />
          <Route
            exact
            path="/orgs/add"
            component={() => (
              <ErrorPage
                code={403}
                message="You do not have access to view this page."
              />
            )}
          />
          <Route exact path="/users" component={Users} />
          <Route
            exact
            path="/users/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/users/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          {/* nested access routes  */}
          <Route exact path="/orgs/addDepartment" component={DepartmentForm} />
          <Route exact path="/orgs/addDoctor" component={DoctorForm} />
          <Route exact path="/orgs/edit/:id" component={AddOrganization} />
          <Route exact path="/orgs/:id" component={OrganisationProfile} />

          {/* orgs doctors routes  */}
          <Route
            exact
            path="/orgs/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />

          {/* orgs depts routes  */}
          <Route
            exact
            path="/orgs/departments/addPatient"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/addDoctor"
            component={DoctorForm}
          />
          <Route
            exact
            path="/orgs/departments/addAdmin"
            component={AdminFormForDeptAdmin}
          />
          <Route
            exact
            path="/orgs/departments/patients/edit/:id"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/patients/:id"
            component={PatientProfile}
          />

          <Route
            exact
            path="/orgs/departments/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />

          <Route
            exact
            path="/orgs/departments/edit/:id"
            component={DepartmentForm}
          />
          <Route
            exact
            path="/orgs/departments/:id"
            component={DepartmentProfile}
          />
          <Route exact path="/appointments" component={AppointmentsList} />
          <Route
            component={() => (
              <ErrorPage
                code={403}
                message="You do not have access to view this page."
              />
            )}
          />
        </Switch>
      );

    case ROLES.ROLE_RECEPTIONIST:
      return (
        <Switch>
          <Route
            exact
            path="/"
            component={() => <Redirect to="/newUpdates" />}
          />
          {/* users routes  */}
          <Route exact path="/profile" component={ProfilePageForUsers} />
          <Route
            exact
            path="/profile/edit"
            component={EditProfileFormForUsers}
          />

          <Route exact path="/followup" component={FollowUpDashboard} />
          <Route exact path="/newUpdates" component={NewUpdates} />
          <Route exact path="/cases/addCase" component={AddCase} />
          <Route exact path="/cases" component={Cases} />
          <Route exact path="/cases/:id" component={Case} />
          <Route exact path="/patients/:id" component={Patient} />
          <Route exact path="/patients" component={Patients} />

          {/* org admin routes  */}
          <Route exact path="/orgs" component={Organizations} />
          <Route
            exact
            path="/orgs/add"
            component={() => (
              <ErrorPage
                code={403}
                message="You do not have access to view this page."
              />
            )}
          />
          <Route exact path="/users" component={Users} />
          <Route
            exact
            path="/users/:id"
            component={ProfilePageFormAdminUsers}
          />
          <Route
            exact
            path="/users/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          {/* nested access routes  */}
          <Route exact path="/orgs/addDepartment" component={DepartmentForm} />
          <Route exact path="/orgs/addDoctor" component={DoctorForm} />
          <Route exact path="/orgs/edit/:id" component={AddOrganization} />
          <Route exact path="/orgs/:id" component={OrganisationProfile} />

          {/* orgs doctors routes  */}
          <Route
            exact
            path="/orgs/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />

          {/* orgs depts routes  */}
          <Route
            exact
            path="/orgs/departments/addPatient"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/addDoctor"
            component={DoctorForm}
          />
          <Route
            exact
            path="/orgs/departments/addAdmin"
            component={AdminFormForDeptAdmin}
          />
          <Route
            exact
            path="/orgs/departments/patients/edit/:id"
            component={PatientForm}
          />
          <Route
            exact
            path="/orgs/departments/patients/:id"
            component={PatientProfile}
          />

          <Route
            exact
            path="/orgs/departments/doctors/edit/:id"
            component={EditProfileFormForAdminUsers}
          />
          <Route
            exact
            path="/orgs/departments/doctors/:id"
            component={ProfilePageFormAdminUsers}
          />

          <Route
            exact
            path="/orgs/departments/edit/:id"
            component={DepartmentForm}
          />
          <Route
            exact
            path="/orgs/departments/:id"
            component={DepartmentProfile}
          />
          <Route exact path="/appointments" component={AppointmentsList} />
          <Route exact path="/appointments/add" component={AppointmentForm} />
          <Route
            component={() => (
              <ErrorPage
                code={403}
                message="You do not have access to view this page."
              />
            )}
          />
        </Switch>
      );

    default:
      return <></>;
  }
};

const mapStateToProps = (state) => {
  return {
    selectedDept: state.ayucareUsers.selectedDept,
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardRoutes);
